import React, { useEffect, useState } from "react";
import xchange from "../../assets/images/xchange.png";
import huobi from "../../assets/images/huobi-global-icon.png";
import binance from "../../assets/images/binance-icon.png";
import kucoin from "../../assets/images/kucoin-icon.png";
import coinbase from "../../assets/images/coinbase-pro-icon.png";
import bitfleyer from "../../assets/images/bitflyer-icon.png";
import ShowSarafi from "./ShowSarafi";
import HotCrypt from "../homeComponent/HotCrypt";
import numberwithCommas from "components/common/numberWithCommas";
const Sarafi = ({ details }) => {
  const [bestsalerial, setBestsalerial] = useState(null);
  const [bestbuyrial, setBestbuyrial] = useState(null);
  const [bestsaleteter, setBestsaleteter] = useState(null);
  const [bestbuyteter, setBestbuyteter] = useState(null);
  const [arrayBox, setArrayBox] = useState([]);
  const data = [
    {
      name: "xchange",
      icon: xchange,
      salePriceRial: 280908,
      buyPriceRial: 270200,
      salePriceTeter: 26401000,
      buyPriceTeter: 26132000,
    },
    {
      name: "Coinbace Pro",
      icon: coinbase,
      salePriceRial: 280908,
      buyPriceRial: 270200,
      salePriceTeter: 26401000,
      buyPriceTeter: 26132000,
    },
    {
      name: "Houbi Global",
      icon: huobi,
      salePriceRial: 280808,
      buyPriceRial: 270234,
      salePriceTeter: 26401000,
      buyPriceTeter: 26540000,
    },
    {
      name: "bitFleyaer",
      icon: bitfleyer,
      salePriceRial: 280908,
      buyPriceRial: 270200,
      salePriceTeter: 26401000,
      buyPriceTeter: 26132000,
    },
    {
      name: "binance",
      icon: binance,
      salePriceRial: 280709,
      buyPriceRial: 270123,
      salePriceTeter: 26900000,
      buyPriceTeter: 26004000,
    },
    {
      name: "kukoin",
      icon: kucoin,
      salePriceRial: 280003,
      buyPriceRial: 270004,
      salePriceTeter: 26012000,
      buyPriceTeter: 26907000,
    },
  ];
  useEffect(() => {
    bestSaleRial();
    bestBuyRial();
    bestSaleTeter();
    bestBuyTeter();
  }, []);

  function bestSaleRial() {
    let temp = data.map((value, index) => ({
      index: index,
      value: value.salePriceRial,
    }));
    let max = temp.reduce(function (prev, current) {
      return prev.value > current.value ? prev : current;
    });
    data.map((value, index) =>
      index === max.index ? setBestsalerial(value) : ""
    );
  }

  function bestBuyRial() {
    let temp = data.map((value, index) => ({
      index: index,
      value: value.buyPriceRial,
    }));
    let max = temp.reduce(function (prev, current) {
      return prev.value > current.value ? prev : current;
    });
    data.map((value, index) =>
      index === max.index ? setBestbuyrial(value) : ""
    );
  }

  function bestSaleTeter() {
    let temp = data.map((value, index) => ({
      index: index,
      value: value.salePriceTeter,
    }));
    let max = temp.reduce(function (prev, current) {
      return prev.value > current.value ? prev : current;
    });
    data.map((value, index) =>
      index === max.index ? setBestsaleteter(value) : ""
    );
  }

  function bestBuyTeter() {
    let temp = data.map((value, index) => ({
      index: index,
      value: value.buyPriceTeter,
    }));
    let max = temp.reduce(function (prev, current) {
      return prev.value > current.value ? prev : current;
    });
    data.map((value, index) =>
      index === max.index ? setBestbuyteter(value) : ""
    );
  }

  useEffect(() => {
    setArrayBox(data.best_price);
  }, [data]);

  return (
    <div className="sarafi">
      {/* {bestsalerial != null &&
      bestbuyrial != null &&
      bestsaleteter != null &&
      bestbuyteter != null ? (
      ) : (
        ""
      )} */}
      {console.log("data", data)}
      <div className="row justify-content-center">
        {details.best_price == undefined ? (
          ""
        ) : (
          <>
            {details.best_price.map((value, index) => {
              return (
                <ShowSarafi
                  key={index}
                  value={value}
                  price={value.price}
                  details={`
                ${value.type == "best_seller" ? "فروش به " : "خرید به "}
                ${value.fiat_type == "IRR" ? "ریال" : "دلار"}
                `}
                />
              );
            })}
          </>
        )}

        {/* {details.cc_meta_data == undefined ? "" : details.cc_meta_data.map} */}
        {/* <ShowSarafi
            value={bestbuyrial}
            price={bestbuyrial.buyPriceRial}
            details={"خرید به ریال"}
          />
          <ShowSarafi
            value={bestsaleteter}
            price={bestsaleteter.salePriceTeter}
            details={"فروش به دلار"}
          />
          <ShowSarafi
            value={bestbuyteter}
            price={bestbuyteter.buyPriceTeter}
            details={"خرید به دلار"}
          /> */}
      </div>
      {/* <HotCrypt
        data={[
          {
            image: xchange,
            informationJSX: (
              <div>
                <p>
                  <span>
                    صرافی
                    <bdi className="mx-2">{data[0].name}</bdi>
                  </span>
                </p>
                <div>قیمت فروش به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[0].salePriceRial)}{" "}
                </div>
                <br />
                <div>قیمت خرید به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[0].buyPriceRial)}
                </div>
                <br />
                <div>قیمت فروش به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[0].salePriceTeter)}
                </div>
                <br />
                <div>قیمت خرید به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[0].buyPriceTeter)}
                </div>
              </div>
            ),
            bgColor: "#4C69DF",
          },
          {
            image: coinbase,
            informationJSX: (
              <div>
                <p>
                  <span>
                    صرافی
                    <bdi className="mx-2">{data[1].name}</bdi>
                  </span>
                </p>
                <div>قیمت فروش به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[1].salePriceRial)}{" "}
                </div>
                <br />
                <div>قیمت خرید به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[1].buyPriceRial)}
                </div>
                <br />
                <div>قیمت فروش به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[1].salePriceTeter)}
                </div>
                <br />
                <div>قیمت خرید به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[1].buyPriceTeter)}
                </div>
              </div>
            ),
            bgColor: "#9196F2",
          },
          {
            image: huobi,
            informationJSX: (
              <div>
                <p>
                  <span>
                    صرافی
                    <bdi className="mx-2">{data[2].name}</bdi>
                  </span>
                </p>
                <div>قیمت فروش به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[2].salePriceRial)}{" "}
                </div>
                <br />
                <div>قیمت خرید به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[2].buyPriceRial)}
                </div>
                <br />
                <div>قیمت فروش به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[2].salePriceTeter)}
                </div>
                <br />
                <div>قیمت خرید به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[2].buyPriceTeter)}
                </div>
              </div>
            ),
            bgColor: "#38ADAD",
          },
          {
            image: bitfleyer,
            informationJSX: (
              <div>
                <p>
                  <span>
                    صرافی
                    <bdi className="mx-2">{data[3].name}</bdi>
                  </span>
                </p>
                <div>قیمت فروش به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[3].salePriceRial)}{" "}
                </div>
                <br />
                <div>قیمت خرید به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[3].buyPriceRial)}
                </div>
                <br />
                <div>قیمت فروش به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[3].salePriceTeter)}
                </div>
                <br />
                <div>قیمت خرید به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[3].buyPriceTeter)}
                </div>
              </div>
            ),
            bgColor: "#E87D4A",
          },
          {
            image: binance,
            informationJSX: (
              <div>
                <p>
                  <span>
                    صرافی
                    <bdi className="mx-2">{data[4].name}</bdi>
                  </span>
                </p>
                <div>قیمت فروش به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[4].salePriceRial)}{" "}
                </div>
                <br />
                <div>قیمت خرید به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[4].buyPriceRial)}
                </div>
                <br />
                <div>قیمت فروش به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[4].salePriceTeter)}
                </div>
                <br />
                <div>قیمت خرید به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[4].buyPriceTeter)}
                </div>
              </div>
            ),
            bgColor: "#4C69DF",
          },
          {
            image: kucoin,
            informationJSX: (
              <div>
                <p>
                  <span>
                    صرافی
                    <bdi className="mx-2">{data[5].name}</bdi>
                  </span>
                </p>
                <div>قیمت فروش به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[5].salePriceRial)}{" "}
                </div>
                <br />
                <div>قیمت خرید به ریال</div>
                <div className="mx-2">
                  {numberwithCommas(data[5].buyPriceRial)}
                </div>
                <br />
                <div>قیمت فروش به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[5].salePriceTeter)}
                </div>
                <br />
                <div>قیمت خرید به تتر</div>
                <div className="mx-2">
                  {numberwithCommas(data[5].buyPriceTeter)}
                </div>
              </div>
            ),
            bgColor: "#9196F2",
          },
        ]}
      /> */}
    </div>
  );
};

export default Sarafi;
